import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { TaskItemStateEnum } from './home-data.data';
import { TaskItem } from './models/submodels/task-item.model';
import { Task } from './models/task.model';

@Injectable()
export class HomeDataService {
  private _headers: any = {
    [ACCEPT_VERSION_HEADER]: '3.0.0',
  };
  private _tasksEndpointHeaders: any = {
    [ACCEPT_VERSION_HEADER]: '5.0.0',
  };

  constructor(private _authHttpService: AuthHttpService) {}

  fetchTask() {
    const url = '/tasks';

    return this._authHttpService
      .get(url, null, this._tasksEndpointHeaders)
      .pipe(
        map(({ body, ..._ }: IResponseInfo) => new Task(body.tasks)),
        catchError((error) => observableThrowError(error))
      );
  }

  /**
   * I realised today(Jan 21, 2021) that the backend
   * has not implemented feature flag for I2G Money
   * as of yet. They plan to. Therefore, created a
   * new method to fetch new version of FTU items
   * till the the backend implements it on their
   * end
   */
  fetchTasksV4() {
    const url = '/tasks';

    const newHeaders = {
      [ACCEPT_VERSION_HEADER]: '4.0.0',
    };

    return this._authHttpService.get(url, null, newHeaders).pipe(
      map(({ body, ..._ }: IResponseInfo) => new Task(body.tasks)),
      catchError((error) => observableThrowError(error))
    );
  }

  setTaskItemState(id: string, state: TaskItemStateEnum) {
    const stateToPathMap = {
      [TaskItemStateEnum.completed]: 'complete',
      [TaskItemStateEnum.dismissed]: 'dismiss',
    };

    const url = `/tasks/${id}/actions/${stateToPathMap[state]}`;

    return this._authHttpService
      .post(url, {}, this._headers)
      .pipe(map(({ body }: IResponseInfo) => new TaskItem(body.task)));
  }

  setTaskCompletion() {
    const url = `/tasks/actions/shown_congratulations`;

    return this._authHttpService.post(url, {}, this._headers);
  }
}
